var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"stat-card"},[_c('div',{staticClass:"stat-card__label"},[_vm._v(_vm._s(_vm.label))]),_c('div',{staticClass:"stat-card__value"},[_vm._v(_vm._s(_vm.value))]),_c('div',{staticClass:"stat-card__hint"},[_vm._v(_vm._s(_vm.hint))])])
}
var staticRenderFns = []

export { render, staticRenderFns }